export const isDemonstrationWorkflow = (record = {}) =>
    Boolean(record.isDemonstration) ||
    record.workflowType === 'demo_installation' ||
    record.workflowType === 'demo_pickup';

export const isSiteInspectionWorkflow = (record = {}) =>
    Boolean(record.isSiteInspection) || record.workflowType === 'site_inspection';

export const filterRowsByProcess = (rows = [], filter = 'all') => {
    if (filter === 'demonstrations') {
        return rows.filter(isDemonstrationWorkflow);
    }
    if (filter === 'movements') {
        return rows.filter((row) =>
            !isDemonstrationWorkflow(row) && !isSiteInspectionWorkflow(row)
        );
    }
    if (filter === 'inspections') {
        return rows.filter(isSiteInspectionWorkflow);
    }
    return rows;
};

export const inferMovementWorkflowType = (workflowType, clientRequestId) => {
    if (workflowType === 'demo_installation' || workflowType === 'demo_pickup') {
        return workflowType;
    }
    if (/^demo:[^:]+:installation$/i.test(clientRequestId || '')) {
        return 'demo_installation';
    }
    if (/^demo:[^:]+:removal$/i.test(clientRequestId || '')) {
        return 'demo_pickup';
    }
    return 'standard';
};

export const getDemonstrationId = (record = {}) => {
    if (record.demonstrationId) return String(record.demonstrationId);
    const match = /^demo:([^:]+):(installation|removal)$/i.exec(
        record.clientRequestId || ''
    );
    return match?.[1] || null;
};

export const consolidateDemonstrationRows = (
    rows = [],
    knownDemonstrations = []
) => {
    const knownIds = new Set(
        knownDemonstrations.map(getDemonstrationId).filter(Boolean)
    );
    const linkedByDemonstration = new Map();

    rows.forEach((row) => {
        if (row.isDemonstration) return;
        const demonstrationId = getDemonstrationId(row);
        if (!demonstrationId) return;
        const linked = linkedByDemonstration.get(demonstrationId) || [];
        linked.push(row);
        linkedByDemonstration.set(demonstrationId, linked);
    });

    return rows.reduce((result, row) => {
        const demonstrationId = getDemonstrationId(row);
        if (row.isDemonstration) {
            result.push({
                ...row,
                linkedMovements: linkedByDemonstration.get(demonstrationId) || []
            });
            return result;
        }
        if (demonstrationId && knownIds.has(demonstrationId)) return result;
        result.push(row);
        return result;
    }, []);
};
